import { render, staticRenderFns } from "./RegisterPageMobileLogo.vue?vue&type=template&id=74401e98&"
import script from "./RegisterPageMobileLogo.vue?vue&type=script&lang=js&"
export * from "./RegisterPageMobileLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports